import React from 'react'
import GenericReportTable from '../../../GenericReportTable'
import { optionsMonth, optionsYear } from "../../../../../common/utils/globalVars";
import Loading from "../../../../../common/components/Loading";
import Pagination from '../../../../../common/components/Pagination';
import { splitArray } from '../../../../../common/utils/utilsFunc';
import { CGE } from '../../../../../common/components/CGE';
import arTitles from "../../../../../common/services/mock/title.json";
import UnconfirmedSubscriptionControllerContextProvider, {
    UnconfirmedSubscriptionControllerContext,
    ACTIONS
} from "../../context/UnconfirmedSubscriptionControllerContextProvider";

function UnconfirmedSubscriptionController({props}) {
    
    const [state, dispatch] = React.useContext(UnconfirmedSubscriptionControllerContext);
    const [values, setValues] = React.useState();
    const [validateInput, setValidateInput] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [auxArray, setAuxArray] = React.useState([])
    const [currentArray, setCurrentArray] = React.useState([])
    const [activePage, setActivePage] = React.useState(1);
    const [rowPage, setRowPageList] = React.useState(10);
    const [newArrTitle, setNewArrTitle] = React.useState(null);

    React.useEffect(() => {
        setNewArrTitle(arTitles['unconfirmed-subscription']?.map(item => item.label));
    } , []);

    function setRowPage(nPage) {
        setActivePage(1);
        setRowPageList(Number(nPage));
      }
    

    function handleSearch() {
        if(!values?.year){
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning")
            setValidateInput(true)
        } else if(!values?.month){
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning")
            setValidateInput(true)
        } else {
            setLoading(true);
            dispatch({
                payload: {year:values?.year,month:values?.month},
                type: ACTIONS.SET_JSON_FORM,
            });
            
        }
    }

    var panelFooter = <>
    {auxArray?.length > 0 && <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
        <Pagination
            items={auxArray}
            onChangePage={setActivePage}
            qtdRowPage={props.qtdRowPage}
            setRowPage={setRowPage}
            pageSize={rowPage}
            currentPg={activePage}
        />
    </div>}
    </>

    React.useEffect(() => {
        let arrayOfarrays = [];
        arrayOfarrays = splitArray(auxArray, rowPage);
        setCurrentArray(arrayOfarrays[activePage - 1]);

    },[activePage, auxArray, rowPage]);

    React.useEffect(() => {
        if(state.dataTable) {
            const objResponse = state.dataTable;
            setLoading(false);

            if(objResponse?.suscripciones.length > 0){
                setAuxArray(objResponse?.suscripciones)
                setValidateInput(false)
            } else if(objResponse?.suscripciones.length === 0) {
                props.setGlobalAlert("No hay registros para estos filtros", "warning", true, "Advertencia");
                setAuxArray([]);
                setValidateInput(false);
            } else {
                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
            }
        }
    },[state.dataTable]);

    let propsTable = {
        'fileName': props.title_page_unconfirmed_subscription,
        'auxArray': auxArray,
        'arTitles': newArrTitle,
        'disabled': currentArray?.length > 0?false:true,
    }

    let panelActions = <>
        <CGE.InlineRow>
            <CGE.InlineCol>
                <CGE.ButtonExcel
                    props={propsTable}
                />
            </CGE.InlineCol>
        </CGE.InlineRow>
    </>
    
  return (
    <div>
        <CGE.Panel 
            title={props.title_page_unconfirmed_subscription}
            footerContent={panelFooter}
            topContent={panelActions}
        >
            <CGE.PanelSection title ={props.section_1_tables_reports}>
                <CGE.Spacing type="mg" />
                <CGE.PanelContainer alingItensCenter={true} size="md">
                    <CGE.FormsField
                        handleChange={(e) => setValues({...values, year: e.target.value})}
                        horizontal={true}
                        idFormElement="filterYear"
                        labelName="Año:"
                        listOptions={optionsYear(props?.number_years_select_page_stock_report?props?.number_years_select_page_stock_report:1)}
                        mandatoryElement={true}
                        style={{ background: '#fff' }}
                        typeElement="select"
                        typeFormElement="text"
                        hasError={validateInput && !values?.year}
                        msgError="Debes seleccionar un año"
                        value={values?.year}
                    />
                    <CGE.FormsField
                        handleChange={(e) => setValues({...values, month: e.target.value})}
                        horizontal={true}
                        idFormElement="filterMonth"
                        labelName="Mes:"
                        listOptions={optionsMonth}
                        mandatoryElement={true}
                        style={{ background: '#fff' }}
                        typeElement="select"
                        typeFormElement="text"
                        hasError={validateInput && !values?.month}
                        msgError="Debes seleccionar un mes"
                        value={values?.month}
                    />
                </CGE.PanelContainer>
                <div className='col-md-12 pt-2 d-flex justify-content-end'>
                    <CGE.Button
                        size="sm"
                        label="Buscar"
                        onClick={() => {handleSearch()}}
                    />
                </div>
            </CGE.PanelSection>
            {currentArray?.length > 0 && 
                <GenericReportTable props={{...props, currentArray, newArrTitle}}/>
            }
        </CGE.Panel>
        {loading && <Loading />}
    </div>
  )
}

const UnconfirmedSubscriptionControllerWithProvider = ({ props }) => (
    <UnconfirmedSubscriptionControllerContextProvider>
        <UnconfirmedSubscriptionController props={props} />
    </UnconfirmedSubscriptionControllerContextProvider>
);
export default UnconfirmedSubscriptionControllerWithProvider;